<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar corretor"
             col-md="col-md-8" offset="offset-3">
    <template v-slot:modalContent>
      <form ref="editarForm" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="nome" v-model="dado.nome" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('nome')" autofocus/>
                <label for="nome"><strong>Nome: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="creci" v-model="dado.creci" size="small" style="width: 100%"/>
                <label for="creci"><strong>CRECI: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="comissao" v-model="dado.comissao" size="small" style="width: 100%"
                             :inputStyle="{ textAlign: 'right' }"
                             :minFractionDigits="2" :maxFractionDigits="5" fluid
                             :invalid="campoVazio.includes('comissao')"/>
                <label for="comissao"><strong>Comissão(%): <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <InputGroup size="small">
                <FloatLabel variant="on">
                  <InputMask id="cep" v-model="dado.cep" size="small" style="width: 100%" mask="99999-999"
                             :invalid="campoVazio.includes('cep')"/>
                  <label for="cep"><strong>CEP: <span class="text-danger font-bold">*</span></strong></label>
                </FloatLabel>
                <InputGroupAddon>
                  <Button icon="pi pi-search" severity="secondary" variant="text" size="small" @click="cepClick"/>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
          <div class="col-md-7">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="endereco" v-model="dado.endereco" size="small" style="width: 100%"/>
                <label for="endereco"><strong>Endereço: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="numero" v-model="dado.numero" size="small" style="width: 100%"/>
                <label for="numero"><strong>Número: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="complemento" v-model="dado.complemento" size="small" style="width: 100%"/>
                <label for="complemento"><strong>Complemento: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="bairro" v-model="dado.bairro" size="small" style="width: 100%"/>
                <label for="bairro"><strong>Bairro: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="cidade" v-model="dado.cidade" size="small" style="width: 100%"/>
                <label for="cidade"><strong>Cidade: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="uf" v-model="dado.uf" size="small" style="width: 100%"/>
                <label for="uf"><strong>UF: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="email_pessoal" type="email" v-model="dado.email_pessoal" size="small" style="width: 100%"/>
                <label for="email_pessoal"><strong>E-mail Pessoal: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="email_financeiro" type="email" v-model="dado.email_financeiro" size="small" style="width: 100%"/>
                <label for="email_financeiro"><strong>E-mail Financeiro: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="email_comercial" type="email" v-model="dado.email_comercial" size="small" style="width: 100%"/>
                <label for="email_comercial"><strong>E-mail Comercial: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputMask id="telefone" v-model="dado.telefone" size="small" style="width: 100%"
                           mask="(99) 9.9999-9999"/>
                <label for="telefone"><strong>Celular: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-9">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="chave_pix" v-model="dado.chave_pix" size="small" style="width: 100%"/>
                <label for="chave_pix"><strong>Chave Pix: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="observacao" v-model="dado.observacao" size="small" style="width: 100%"/>
                <label for="observacao"><strong>Observação: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.status"
                    inputId="status"
                    :options="status"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('status')"
                />
                <label for="status">
                  <strong>Status: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {buscarCep} from '../../../public/js/api/buscar_cep';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "EditarCliente",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
  },
  emits: ["fechar", "atualizarDados"],
  data() {
    return {
      dado: 1,
      erro: null,
      campoVazio: [],
      status: [
        {label: 'ATIVO', value: 'A'},
        {label: 'INATIVO', value: 'I'}
      ],
    }
  },
  methods: {
    async cepClick() {
      await buscarCep(this.dado.cep, this.dado)
    },
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.corretores.retrieveUpdateDestroy(this.itemKey)}?modo=edit`);
      if (resultado.success) {
        this.dado = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      const resultado = await apiRequest("PATCH", apiUrl.corretores.retrieveUpdateDestroy(this.itemKey), this.dado);
      if (resultado.success) {
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error)
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
